import React from 'react'
import CloseIcon from '@material-ui/icons/Close'
import {
  Box,
  Button,
  Dialog, DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { FormattedMessage } from 'react-intl'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../Loader/FormLoader'
import { useStyles } from './Styles'
import Moment from 'react-moment'
import Item from '../CompanyPage/CompaniesInfo/Item'
import { LanguageConsumer } from '../../../LanguageContext'
// import eCommerceUINFile from './../../../images/eCommerce-UIN.pdf'
// import pdfIcon from './../../../images/pdf.png'

const EcommerceUINGenerate = ({ Transition, regenerate, generateEcommerceUIN, resetEcommerceUINStatus }) => {
  const classes = useStyles()

  const [viewEcommerceUINDialog, setViewEcommerceUINDialog] = React.useState(false)
  const [openEcommerceUINDialog, setOpenEcommerceUINDialog] = React.useState(false)
  const handleEcommerceUINDialog = () => {
    if (!openEcommerceUINDialog) {
      generateEcommerceUIN()
      setViewEcommerceUINDialog(true)
    } else {
      setTimeout(() => {
        setViewEcommerceUINDialog(false)
        resetEcommerceUINStatus()
      }, 500)
    }
    setOpenEcommerceUINDialog(!openEcommerceUINDialog)
  }

  return (
    <div className={classes.DashboardActionLinksItem}>
      <h4><FormattedMessage id='DashboardContent.ActionLinks.ecommerceUIN.title'/></h4>
      <Button size="large" onClick={handleEcommerceUINDialog} variant="contained" color="primary">
        <FormattedMessage id={`DashboardContent.ActionLinks.ecommerceUIN.${!!regenerate || 'false'}`}/>
      </Button>
      {!!viewEcommerceUINDialog &&
      <Dialog
        keepMounted
        fullWidth
        maxWidth={'md'}
        open={openEcommerceUINDialog}
        classes={{ paper: classes.LinkCompanyDialogPaper }}
        TransitionComponent={Transition}
        onClose={handleEcommerceUINDialog}
        aria-labelledby="BasicInfoDialog"
        aria-describedby="BasicInfoDialog"
      >
        <AuthenticatedUserConsumer>
          {({ eCommerceUINData, eCommerceUINFailure, eCommerceUINFailureMessage, eCommerceUINLoading }) => (
            <>
              <DialogTitle disableTypography className={classes.LinkCompanyDialogHeader}>
                <Typography variant="h5"><FormattedMessage
                  id='DashboardContent.ActionLinks.ecommerceUIN.title'/></Typography>
                <IconButton
                  edge={false}
                  className={classes.LinkCompanyDialogClose}
                  color="inherit"
                  aria-label="close dialog"
                  onClick={handleEcommerceUINDialog}
                >
                  <CloseIcon/>
                </IconButton>
              </DialogTitle>
              <DialogContent className={classes.LinkCompanyDialogContent}>
                <Box px={4} pt={4} pb={0} className={classes.EcommerceUINWrapper}>

                  {!!eCommerceUINFailure && !!eCommerceUINFailureMessage &&
                  <Alert severity="error">{eCommerceUINFailureMessage}</Alert>
                  }

                  {!!eCommerceUINLoading && <FormLoader loading={true}/>}

                  {!!Object.keys(eCommerceUINData || {}).length && <>

                    <Alert severity="warning"><FormattedMessage id='eCommerceUIN.FormSuccessAlert'/></Alert>
                    <Box my={3} className={classes.EcommerceUINContent}>
                      <Item asTable label={<FormattedMessage id='eCommerceUIN.uin'/>}
                            value={eCommerceUINData?.uin || 'N/A'}/>

                      <LanguageConsumer>
                        {({ locale }) => (
                          <Item asTable label={<FormattedMessage id='eCommerceUIN.expiry_date'/>}
                                value={eCommerceUINData?.expiry_date ?
                                  <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                          format="Do MMMM YYYY">{eCommerceUINData?.expiry_date}</Moment> : 'N/A'}/>
                        )}
                      </LanguageConsumer>

                      {/*<Item asTable label={<FormattedMessage id='eCommerceUIN.pdfFile.title'/>}*/}
                      {/*      value={<a href={eCommerceUINFile} download><img className={classes.pdfIcon} src={pdfIcon}*/}
                      {/*                                                      alt={'PDF'}/>*/}
                      {/*        <FormattedMessage id='eCommerceUIN.pdfFile'/></a>}/>*/}

                    </Box>
                  </>}

                </Box>
              </DialogContent>
              <DialogActions className={classes.LinkCompanyDialogFooter}>
                <Button onClick={handleEcommerceUINDialog} color="primary">
                  <FormattedMessage id='PaymentOrder.ActionLinks.close'/>
                </Button>
              </DialogActions>
            </>
          )}
        </AuthenticatedUserConsumer>
      </Dialog>
      }
    </div>
  )
}

export default EcommerceUINGenerate
